import { render, staticRenderFns } from "./Rem.vue?vue&type=template&id=1260e9f4&"
import script from "./Rem.vue?vue&type=script&lang=js&"
export * from "./Rem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports